<div class="list list-card" *rxIf="coupons?.length; else empty; renderCallback: render$">
    @for (item of coupons; track item.id) {
        <ms-list-item
            msTrackReferringActionDirective
            [trackingValue]="getTracking(item)"
            [cleanAfterTrack]="cleanedAfterTrack()"
            [icon]="epcotEnabled && !item.active ? 'theme-coupon' : 'sports-coupons-icon'"
            [iconSize]="16"
            [isActive]="item.active"
            [title]="getTitle(item)"
            [boldTitle]="item.active"
            [href]="utilsService.getUrl(item, sport)"
            [arrow]="false"
            [isShowBorder]="!$last"
            [badge]="true"
            (itemClicked)="trackCouponClick(item)">
            @if ('item.type === couponType.BetBuilder') {
                <span badge>
                    @if (showBetbuilderNewBadge) {
                        <span class="new-badge"> {{ sitecore.betBuilder.messages.NewBadge }}</span>
                    }
                </span>
            }
        </ms-list-item>
    }
</div>
<ms-component-loader *rxIf="showLoader$; strategy: 'native'" />
<ng-template #empty> <ms-error severity="info" [message]="sitecore.coupons.noCoupons"></ms-error> </ng-template>
